import { createStore } from 'redux';
import rootReducer from './reducers';
import { loadState, saveState } from '../services/storage-service';

let state = loadState("state");

let persistedState = {}

if (state !== undefined) {
    persistedState = state
}

const store = createStore(rootReducer, persistedState);

store.subscribe(() => {
    let state = store.getState();
    saveState({
        auth: state.auth,
    });
});

export default store;
